<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              Patient's Visits
              <v-spacer></v-spacer>
              <v-btn small text @click="goTo('/clients/' + client.id + '/visits/create')">Add</v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headers" :search="filterBy" :items="visits">
                <template v-slot:item="{ item }">
                  <tr @click="goTo('/clients/' + client.id + '/visits/' + item.id)">
                    <td>{{ item.date }}</td>
                    <td>{{ item.user_name }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <span class="red--text">{{ client.name }}</span>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import Layout from '@/Layouts/MainLayout'

  export default {
    name: 'Visits',
    layout: Layout,
    metaInfo () {
      return {
        title: 'Patient\'s Visits',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    props: ['visits', 'client'],
    data () {
      return {
        headers: [
          {
            text: 'Date', value: 'date'
          },
          {
            text: 'User', value: 'user_name'
          },
        ],
      }
    },
  }
</script>
